<script>
import { mapActions } from 'vuex';

export default {
    data() {
        return {
            users: [],
            internal_stakeholders: [],
            roles: [],
            departments: [],

            internal_stakeholder_search_keyword: null,

            headers: [
                { key: '#', flex: 1 },
                { key: 'name', flex: 4 },
                { key: 'email', flex: 6 },
                { key: 'role_name', flex: 4 },
                { key: 'user_department_name', flex: 4 },
                { key: 'edit', flex: 1 },
                { key: 'delete', flex: 1 },
            ],

            internal_stakeholder_headers: [
                { key: '#', flex: 1 },
                { key: 'name', flex: 4 },
                { key: 'email', flex: 6 },
                { key: 'role_name', flex: 4 },
                { key: 'user_department_name', flex: 5 },
                { key: 'promote', flex: 1 },
            ],

            userToCreate: {
                user_department_id: null,
                role_id: null,
                firstname: null,
                surname: null,
                email: null,
                user_language: null,
            },
            userToUpdate: null,
            userToUpdateCopy: null,
        }
    },

    watch: {
        internal_stakeholder_search_keyword(newVal) {
            if (newVal === '') {
                this.internal_stakeholder_search_keyword = null;
            }
        }
    },

    mounted() {
        this._getTeamMembers();
        this._getInternalStakeholders();
    },

    methods: {
        ...mapActions('settings', [
            'getTeamMembers',
            'getInternalStakeholders',
            'registerUser',
            'updateUser',
            'deleteUser',
        ]),

        _getTeamMembers() {
            this.getTeamMembers()
                .then(res => {
                    this.users = res.data.team_members;
                    this.roles = res.data.roles;
                    this.departments = res.data.departments;
                })
        },

        _getInternalStakeholders() {
            this.getInternalStakeholders({keyword: this.internal_stakeholder_search_keyword})
                .then(res => {
                    this.internal_stakeholders = res.data;
                })
        },

        async _registerUser() {
            const params = {
                created_by: this.$user.user_id,
                company_id: this.$user.company_id,
                user_department_id: this.userToCreate.user_department_id,
                role_id: this.userToCreate.role_id,
                firstname: this.userToCreate.firstname,
                surname: this.userToCreate.surname,
                email: this.userToCreate.email,
                user_language: this.userToCreate.user_language,
                expert_firstname: this.userToCreate.firstname,
                expert_surname: this.userToCreate.surname
            };

            await this.registerUser(params)
                .then(res => {
                    const department = this.departments.find(dep => dep.user_department_id === this.userToCreate.user_department_id);
                    const role = this.roles.find(role => role.role_id === this.userToCreate.role_id);
                    this.users.push({
                        ...this.userToCreate,
                        user_department_name: department ? department.user_department_name : '',
                        role_name: role ? role.role_name : '',
                        user_id: res.data.user_id,
                    });

                    this.$notify('success', res.data.messageName);
                    this.resetRegisterUser();
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },

        _updateUser() {
            let params = {
                user_id: this.userToUpdate.user_id,
                body: {}
            };

            for (let i = 0; i < Object.keys(this.userToUpdate).length; i++) {
                const key = Object.keys(this.userToUpdate)[i];
                
                if (Object.prototype.hasOwnProperty.call(this.userToUpdateCopy, key) && this.userToUpdateCopy[key] != this.userToUpdate[key] && key != 'user_id') {
                    Object.assign(params.body, { [key]: this.userToUpdate[key] });
                }
            }

            this.updateUser(params)
                .then(res => {
                    const idx = this.users.findIndex(x => x.user_id === params.user_id);
                    for (const key in params.body) {
                        if (!Object.hasOwn(params.body, key)) continue;
                        
                        const value = params.body[key];
                        this.users[idx][key] = value;
                    }

                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },

        _deleteUser() {
            const params = {
                user_id: this.userToUpdate.user_id
            }

            this.deleteUser(params)
                .then(res => {
                    this.$notify('success', res.data.messageName);
                    this.users = this.users.filter(user => user.user_id !== this.userToUpdate.user_id);
                    this.resetUpdateUser();
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },

        handleClickRegister() {
            this.$refs.createPopup.openPopup();
        },

        handleClickEdit(user) {
            this.userToUpdate = user;
            this.userToUpdateCopy = structuredClone(user);
            this.$refs.editPopup.openPopup();
        },

        handleClickPromote(user) {
            const params = {
                user_id: user.user_id,
                body: {
                    role_id: 5
                },
            };

            this.updateUser(params)
                .then(res => {
                    user.role_id = 5;
                    user.role_name = this.roles.find(x => x.role_id === 5).role_name;
                    this.users.push(user);
                    this.internal_stakeholders = this.internal_stakeholders.filter(x => x.user_id !== params.user_id);
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },

        handleClickDelete(user) {
            this.userToUpdate = user;
            this.$refs.deletePopup.openPopup();
        },

        resetRegisterUser() {
            this.userToCreate =  {
                user_department_id: null,
                role_id: null,
                firstname: null,
                surname: null,
                email: null,
                user_language: null,
            };
        },

        resetUpdateUser() {
            this.userToUpdate = null;
        },

        resetInternalKeyword() {
            this.internal_stakeholder_search_keyword = null;
            this._getInternalStakeholders();
        },
    }
}
</script>

<template>
    <div class="flex-all-centered-col">
        <div class="group-title">
            {{ $t('team_members.team_members') }}
        </div>
        <div class="users-table flex-all-centered-col">
            <div class="header-row flex-all-centered-row">
                <div v-for="header in headers" :key="header.key" 
                    :style="{
                        'flex': header.flex
                    }"
                >
                    <span v-if="header.key === '#'">#</span>
                    <span v-else>{{ $t(`team_members.headers.${header.key}`) }}</span>
                </div>
            </div>
            <div v-for="(user, idx) in users" :key="user.user_id" class="user-row flex-all-centered-row">
                <div v-for="header in headers" :key="header.key" :style="{
                        'flex': header.flex
                    }">
                    <div v-if="header.key === '#'" style="text-align: center;">
                        {{ idx + 1 }}
                    </div>
                    <div v-else-if="header.key === 'name'">
                        {{ user.firstname }} {{ user.surname }}
                    </div>
                    <button v-else-if="header.key === 'edit'" class="icon-button" @click="handleClickEdit(user)">
                        <i class="fa-regular fa-pen-to-square" style="color: var(--sustainfinity-blue);"></i>
                    </button>
                    <button v-else-if="header.key === 'delete'" class="icon-button" @click="handleClickDelete(user)">
                        <i class="fa-solid fa-trash" style="color: var(--invalid-input);"></i>
                    </button>
                    <div v-else>
                        {{ user[header.key] }}
                    </div>
                </div>
            </div>
            <div v-if="users.length === 0" class="user-row flex-all-centered-row"
                style="justify-content: center !important; padding: .5em;">
                {{ $t('team_members.no_members') }}
            </div>
        </div>

        <br><br>

        <div class="group-title">
            {{ $t('team_members.internal_stakeholders') }}
        </div>

        <div class="searchbar">
            <input type="text" 
                v-model="internal_stakeholder_search_keyword" 
                :placeholder="$t('userCompany.user.search_placeholder')"
                @change="_getInternalStakeholders()"
            >
            <button class="search-btn" @click="_getInternalStakeholders()">
                <i class="fa-solid fa-magnifying-glass"></i>
            </button>

            <button class="reset-btn" @click="resetInternalKeyword()">
                <i class="fa-solid fa-rotate-left"></i>
            </button>
        </div>

        <br>

        <div class="users-table flex-all-centered-col">
            <div class="header-row flex-all-centered-row">
                <div v-for="header in internal_stakeholder_headers" :key="header.key" :style="{
                        'flex': header.flex
                    }">
                    <span v-if="header.key === '#'">#</span>
                    <span v-else>{{ $t(`team_members.headers.${header.key}`) }}</span>
                </div>
            </div>
            <div v-for="(user, idx) in internal_stakeholders" :key="user.user_id"
                class="user-row flex-all-centered-row">
                <div v-for="header in internal_stakeholder_headers" :key="header.key" 
                    :style="{
                        'flex': header.flex
                    }"
                >
                    <div v-if="header.key === '#'" style="text-align: center;">
                        {{ idx + 1 }}
                    </div>
                    <div v-else-if="header.key === 'name'">
                        {{ user.firstname }} {{ user.surname }}
                    </div>
                    <button v-else-if="header.key === 'promote'" 
                        class="sust-btn sust-btn-green" 
                        style="box-shadow: none;"
                        @click="handleClickPromote(user)"
                    >
                        <i class="fa-solid fa-turn-up"></i>
                    </button>
                    <div v-else>
                        {{ user[header.key] }}
                    </div>
                </div>
            </div>
            <div v-if="internal_stakeholders.length === 0" class="user-row flex-all-centered-row"
                style="justify-content: center !important; padding: .5em;">
                {{ $t('team_members.no_members') }}
            </div>
        </div>

        <button class="sust-btn sust-btn-green" style="align-self: flex-end; margin-top: 1em;"
            @click="handleClickRegister()">
            {{ $t('userCompany.user.create_single') }}
        </button>

        <sust-popup ref="createPopup" size="lg" :title="$t('userCompany.user.update_title')" @ok="_registerUser()">
            <div class="edit-form">
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.role') }}
                    </label>
                    <select v-model="userToCreate.role_id" name="editField">
                        <option v-for="item in roles" :key="item.role_id" :value="item.role_id">
                            {{ item.role_name }}
                        </option>
                    </select>
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.department') }}
                    </label>
                    <select v-model="userToCreate.user_department_id" name="editField">
                        <option v-for="item in departments" :key="item.user_department_id"
                            :value="item.user_department_id">
                            {{ item.user_department_name }}
                        </option>
                    </select>
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.name') }}
                    </label>
                    <input v-model="userToCreate.firstname" name="editField" type="text">
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.surname') }}
                    </label>
                    <input v-model="userToCreate.surname" name="editField" type="text">
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.email') }}
                    </label>
                    <input v-model="userToCreate.email" name="editField" type="text">
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.language') }}
                    </label>
                    <select name="editField" v-model="userToCreate.user_language">
                        <option value="En">
                            {{ $t('userCompany.user.en') }}
                        </option>
                        <option value="Tr">
                            {{ $t('userCompany.user.tr') }}
                        </option>
                    </select>
                </div>
            </div>
        </sust-popup>

        <sust-popup ref="editPopup" size="lg" :title="$t('userCompany.user.update_title')" @ok="_updateUser()"
            @onHide="resetUpdateUser()">
            <div class="edit-form" v-if="userToUpdate">
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.role') }}
                    </label>
                    <select v-model="userToUpdate.role_id" name="editField">
                        <option v-for="item in roles" :key="item.role_id" :value="item.role_id">
                            {{ item.role_name }}
                        </option>
                    </select>
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.department') }}
                    </label>
                    <select v-model="userToUpdate.user_department_id" name="editField">
                        <option v-for="item in departments" :key="item.user_department_id"
                            :value="item.user_department_id">
                            {{ item.user_department_name }}
                        </option>
                    </select>
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.name') }}
                    </label>
                    <input v-model="userToUpdate.firstname" name="editField" type="text">
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.surname') }}
                    </label>
                    <input v-model="userToUpdate.surname" name="editField" type="text">
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.email') }}
                    </label>
                    <input v-model="userToUpdate.email" name="editField" type="text">
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.language') }}
                    </label>
                    <select name="editField" v-model="userToUpdate.user_language">
                        <option value="En">
                            {{ $t('userCompany.user.en') }}
                        </option>
                        <option value="Tr">
                            {{ $t('userCompany.user.tr') }}
                        </option>
                    </select>
                </div>
            </div>
        </sust-popup>

        <sust-popup ref="deletePopup" size="sm" :title="$t('userCompany.user.delete_title')" @ok="_deleteUser()"
            @hidden="resetUpdateUser()">
            <div>
                {{ $t('userCompany.user.delete_text') }}
            </div>
        </sust-popup>
    </div>
</template>

<style lang='scss' scoped>
    .users-table {
        border-radius: 1em;
        overflow: hidden !important;
        box-shadow: 0 .25em .5em .1em gray;
    }

    .group-title {
        color: black;
        font-weight: bold;
        font-size: 1.2em;
        text-align: left;
        padding: .35em;
        width: 100%;
    }

    .header-row {
        overflow: hidden !important;
        background-color: var(--sustainfinity-navy);
        color: whitesmoke;
        border-top-left-radius: 1em;
        border-top-right-radius: 1em;

        > div {
            border-right: thin solid whitesmoke;
            &:last-of-type {
                border-right: 0 !important;
            }
        }
    }
    
    .user-row {
        overflow: hidden !important;
        background-color: whitesmoke;
        color: var(--sustainfinity-navy);
        border-bottom: thin solid lightgray;

        &:last-of-type {
            border-bottom: 0 !important;
            border-bottom-left-radius: 1em;
            border-bottom-right-radius: 1em;
        }

        > div {
            &:last-of-type {
                border-right: 0 !important;
            }
        }
    }

    .header-row, .user-row {
        justify-content: flex-start;
        align-items: stretch;
        > div {
            padding: 1em;
        }
    }

    .icon-button {
        > i {
            transition: filter 150ms;
        }

        &:hover {
            > i {
                filter: brightness(.7);
            }
        }
    }

    .edit-form {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: stretch;
        flex-wrap: wrap;

        > .small-field {
            width: 40%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;

            > * {
                text-align: left;
                width: 100%;
            }

            > label {
                margin: 0dvh;
            }

            > input, textarea, select {
                padding: .35em .1em;
                border-radius: .25em;
                border: 0;
                outline: thin solid lightgray;

                &:focus {
                    outline: thin solid black !important;
                }
            }
        }
    }

    .searchbar {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        align-self: flex-start;
        width: 50% !important;
        margin: 0 !important;
        margin-top: 1em !important;
            
        > input {
            width: 100%;
            border: 0;
            outline: thin solid lightgray;
            border-radius: 100px;
            padding: .5em;
            background-color: whitesmoke;
            &:focus {
                outline: thin solid gray !important;
            }
        }
        position: relative;
        > .search-btn {
            transform-origin: (50%, 50%);
            position: absolute;
            right: 4.5em;
            top: 50%;
            transform: translateY(-60%);
            background: none;
            border: 0;
            outline: 0;
            scale: .8;
            transition: all 150ms;
            &:hover {
                scale: 1;
            }
            &:focus {
                outline: thin solid lightgray !important;
                > i {
                    color: black !important;
                }
            }
        }
        > .reset-btn {
            position: relative;
            background-color: var(--sustainfinity-yellow);
            color: white;
            padding: .3em 1em;
            margin-left: .5em;
            border: 0;
            outline: thin solid gray;
            border-radius: .5em;
            
            transition: all 150ms;
            &:hover {
                filter: brightness(90%);
            }
            &:focus {
                outline: thin solid black !important;
            }
            &:active {
                outline: .125em solid black !important;
            }
        }
    }
</style>